import { create } from 'zustand'

import * as dashboardApi from '../api/dashboard.api'

export const useMarketingDashboardStore = create((set, get) => ({
  campaignLeads: null,
  conversionRate: null,
  ordersClosed: null,
  ordersLost: null,
  leadsManagement: null,
  campaignPerformance: [],

  isLoading: true,
  hasLoaded: false,
  error: null,

  clearError: () => set({ error: null }),

  fetchDashboard: async (period = 'all', customRange = {}) => {
    const { hasLoaded } = get()

    set({
      isLoading: !hasLoaded,
      error: null,
    })

    try {
      const response = await dashboardApi.getMarketingDashboard({
        period,
        ...customRange,
      })

      const payload = response?.data ?? {}

      set({
        campaignLeads: payload?.campaignLeads || null,
        conversionRate: payload?.conversionRate || null,
        ordersClosed: payload?.ordersClosed || null,
        ordersLost: payload?.ordersLost || null,
        leadsManagement: payload?.leadsManagement || null,
        campaignPerformance: payload?.campaignPerformance || [],
        isLoading: false,
        hasLoaded: true,
        error: null,
      })

      return response
    } catch (error) {
      const message = error?.message || 'Failed to load marketing dashboard'

      set({
        isLoading: false,
        error: message,
      })
    }
  },
}))
